import {Injectable} from '@angular/core';
import {CurrentUIState, uiState} from 'src/models/UIState';
import {BehaviorSubject, Observable} from 'rxjs';
import {AsgardFeatureNames} from 'src/models/AsgardFeatures';
import { GoogleAnalyticsService } from '../google-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentUiStoreService {
  uiState: BehaviorSubject<CurrentUIState> = new BehaviorSubject<CurrentUIState>(uiState);

  constructor(private readonly googleAnalyticsService: GoogleAnalyticsService) {
  }

  getUIState(): Observable<CurrentUIState> {
    return this.uiState.asObservable();
  }

  disableState = (features: AsgardFeatureNames | AsgardFeatureNames[]) => {
    const state = this.uiState.getValue();
    if (features instanceof Array) {
      state.setListOfFeaturesDisabled(features);
    } else if (features) {
      state.disableFeature(features);
    }
    this.uiState.next(state);
  }

  enableState = (features: AsgardFeatureNames | AsgardFeatureNames[]) => {
    const state = this.uiState.getValue();
    if (features instanceof Array) {
      state.enableListOfFeatures(features);
    } else if (features) {
      state.enableFeature(features);
    }
    this.uiState.next(state);
  }


  setItemActive = (features: AsgardFeatureNames | AsgardFeatureNames[]) => {
    const state = this.uiState.getValue();
    if (features instanceof Array) {
      state.setListOfFeaturesActive(features);
      features.forEach(feature => this.trackGoogleAnalyticsEvent(feature));
    } else if (features) {
      state.setFeatureActive(features);
      this.trackGoogleAnalyticsEvent(features);
    }
    this.uiState.next(state);
  }

  setItemUnActive = (features: AsgardFeatureNames | AsgardFeatureNames[]) => {
    const state = this.uiState.getValue();
    if (features instanceof Array) {
      state.setListOfFeaturesUnActive(features);
    } else if (features) {
      state.setFeatureUnActive(features);
    }
    this.uiState.next(state);
  }

  setItemLocked = (features: AsgardFeatureNames | AsgardFeatureNames[]) => {
    const state = this.uiState.getValue();
    if (features instanceof Array) {
      state.setListOfFeaturesLocked(features);
    } else if (features) {
      state.lockFeature(features);
    }
    this.uiState.next(state);
  }

  setItemUnlocked = (features: AsgardFeatureNames | AsgardFeatureNames[]) => {
    const state = this.uiState.getValue();
    if (features instanceof Array) {
      state.setListOfFeaturesUnlocked(features);
    } else if (features) {
      state.unlockFeature(features);
    }
    this.uiState.next(state);
  }

  toggleElement = (el: AsgardFeatureNames) => {
    const state = this.uiState.getValue();
    const prev = state[el].active;
    if (prev) {
      this.setItemUnActive(el);
    } else {
      this.setItemActive(el);
    }
  }

  checkElementState = (el: AsgardFeatureNames): boolean => {
    const state = this.uiState.getValue();
    const prev = state[el].active;
    return !!prev;
  }

  public deattachPointerEventsOnViewerAndEditorsFrames = (on: boolean): void => {
    const viewers = document.getElementsByClassName('viewer');
    const editors = document.getElementsByClassName('fr-wrapper');

    const viewersEditorsArray = [...Array.from(viewers), ...Array.from(editors)];

    if (viewersEditorsArray.length) {
      viewersEditorsArray.forEach(el => {
        const frame = el.firstElementChild;
        if (frame) {
          if (on) {
            (frame as HTMLElement).style.pointerEvents = 'none';
          } else {
            (frame as HTMLElement).style.pointerEvents = 'auto';
          }
        }
      });
    }
  };

  private trackGoogleAnalyticsEvent(feature: AsgardFeatureNames): void {
    if (this.googleAnalyticsService.featuresToTrack.includes(feature)) {
      this.googleAnalyticsService.trackFeature(feature);
    }
  }

}
